import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { LoopCircleLoading } from "react-loadingg";
import ExWeapon from "../components/ExWeapon";
import AboutExWeapons from "./AboutExWeapons";

export default function ExWeaponList() {
  const [exWeapons, setExWeapons] = useState([]);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    fetch("https://revived-witch-api.herokuapp.com/api/equips/exWeapons")
      .then((res) => res.json())
      .then(
        (result) => {
          setExWeapons(result.exWeapons);

          setIsLoaded(true);
        },
        (error) => {
          setError(error);
          setIsLoaded(true);
        }
      );
  }, []);

  if (error) {
    return <>{error.message}</>;
  } else if (!isLoaded) {
    return (
      <div style={{ height: "100vh", weight: "50%" }}>
        <LoopCircleLoading />
      </div>
    );
  } else {
    return (
      <>
        <Grid
          container
          style={{
            marginBottom: 30,
            marginTop: 30,
            justify: "center",
          }}
        >
          <Grid item xs={12} md={12} sm={12}>
            <AboutExWeapons />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={2}
          style={{
            marginBottom: 30,
            marginTop: 30,
            justify: "space-between",
            alignItems: "stretch",
          }}
        >
          {exWeapons.map((eq, index) => (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              sm={6}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <ExWeapon key={eq._id} data={eq} />
            </Grid>
          ))}
        </Grid>
      </>
    );
  }
}
